import { Icon, IconProps } from '@chakra-ui/react';

export const ToastSuccessIcon = (props: IconProps) => (
  <Icon width='51px' height='52px' viewBox='0 0 51 52' fill='none' {...props}>
    <circle cx='25.6636' cy='25.9739' r='25.1313' fill='white' />
    <path
      d='M38.5516 38.8618H12.7759V35.1795H38.5516V38.8618ZM21.9815 30.4294L14.617 23.065L17.213 20.469L21.9815 25.2191L34.1145 13.0861L36.7105 15.7005L21.9815 30.4294Z'
      fill='#71BD4D'
    />
  </Icon>
);
